import PublicLayout from "../PublicLayout";

const EnquireLayout = () => (
  <PublicLayout surface="conversion" footerVariant="compact" showFooterCta={false} />
);

export default EnquireLayout;
